import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { Button } from '@wds/button';
import { generateMetricsAttribute } from '@sm/metrics';
import { Logo, LogoWithText, MobileTabletScreen, DesktopScreen } from '@sm/webassets';
import { createURL } from '@sm/utils';

import useStyles from './useStyles';

const COPY = defineMessages({
  SIMPLE_HERO_FORM_CALLOUT_BOLD_HEADER: {
    id: 'SimpleHero.SimpleHeroFormCalloutBoldHeader',
    defaultMessage: 'Get answers with surveys',
    description:
      "[Type: Header][Vis: high] - The Hero's Primary tagline. A brief description of SurveyMonkey's functionality.",
  },
  SIMPLE_HERO_FORM_CALLOUT_CTA: {
    id: 'SimpleHero.SimpleHeroFormCalloutCTA',
    defaultMessage: 'CREATE SURVEY',
    description:
      "[Type: Header][Vis: high] - The Hero's only CTA. It takes user's to a login screen or directly to a dashboard to create their survey.",
  },
});

export type Props = {
  hideCTAs?: boolean;
  utSource?: string;
  utSource2?: string;
};

const SimpleHero: React.FC<Props> = ({
  hideCTAs = true,
  utSource = 'survey_thanks',
  utSource2 = 'rebrand_existing_user',
}) => {
  const { smSimpleHero, logo, smGoldie, smWebRespWebButton, text } = useStyles();

  return (
    <Box
      data-testid="SimpleHero"
      className={smSimpleHero}
      display="flex"
      flexDirection="column"
      flexAlign="center"
      px={3}
      pt={7}
      pb={8}
    >
      <DesktopScreen>
        <a data-testid="SimpleHero__Logo" aria-label="Survey Monkey Home" href={createURL('/', {})}>
          <LogoWithText color="alt" className={logo} />
        </a>
        <Box mx={1} mt={7} mb={5}>
          <Typography component="h3" color="light" variant="hero1" align="center">
            <strong>{t(COPY.SIMPLE_HERO_FORM_CALLOUT_BOLD_HEADER)}</strong>
          </Typography>
        </Box>
      </DesktopScreen>
      <MobileTabletScreen>
        <a
          aria-label="Survey Monkey Home"
          data-testid="SimpleHero__Goldie"
          href={createURL('/', {})}
          className={smGoldie}
        >
          <Logo color="alt" className={text} />
        </a>
        <Box mx={1} mt={7} mb={5}>
          <Typography component="h3" color="light" variant="pageTitle" align="center">
            <strong>{t(COPY.SIMPLE_HERO_FORM_CALLOUT_BOLD_HEADER)}</strong>
          </Typography>
        </Box>
      </MobileTabletScreen>
      {!hideCTAs && (
        <Box className={smWebRespWebButton}>
          <Button
            size="lg"
            color="upgrade"
            href={createURL('/create/', {
              ut_source: utSource,
              ut_source2: utSource2,
            })}
            data-sm-metric={generateMetricsAttribute({
              data: {
                actionType: `${utSource}_click_${utSource2}_cta_to_create`,
                actionFlow: { utSource },
              },
            })}
          >
            {t(COPY.SIMPLE_HERO_FORM_CALLOUT_CTA)}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default SimpleHero;
